<div class="liked-profiles-container">
  <ion-icon 
    class="heart" 
    src="assets/imgs/custom-svg/like_heart.svg" 
    style="font-size: 22px;" 
    (click)="openLikedProfiles()">
  </ion-icon>
  
  <div class="notification" *ngIf="newLikes > 0">
    {{ newLikes > 99 ? '+99' : newLikes }}
  </div>
</div>
